// extracted by mini-css-extract-plugin
export default {"item":"AreaItem_item__opOcC","selected":"AreaItem_selected__4CB6X"};